import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { About } from "@/components/landing/About";
import { VisionMission } from "@/components/landing/VisionMission";
import { Services } from "@/components/landing/Services";
import { Projects } from "@/components/landing/Projects";
import { Battery } from "@/components/landing/Battery";
import { Faq } from "@/components/landing/Faq";
import { Milestones } from "@/components/landing/Milestones";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <VisionMission />
        <Services />
        <Projects />
        <Battery />
        <Faq />
        <Milestones />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
